import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';

import { BookingSessionsToolbar, BookingSessionsTable } from './components';

import CircularProgress from '@mui/material/CircularProgress';



import { useDispatch } from 'react-redux';


import API from 'util/API';
import {
  showErrorSnackbar,
} from "store/actions/snackbarMessage";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	}
}));


const BookingSessionList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const [uiLoading, setUiLoading] = useState(false);
  
  const [sessions, setSessions] = useState([])

  const showError = (msg) => dispatch(showErrorSnackbar(msg));
  


  


  const getSessions = async () => {
    setUiLoading(true);

    try {
      const response = await API.get('/allBookingSessions');
      if (response && response.data && response.data.sessions) {
        setUiLoading(false);
         setSessions(response.data.sessions);
      } else {
        setUiLoading(false);
        showError("Something went wrong, please try again");
      }

    }catch (err) {
      setUiLoading(false);
      showError("Something went wrong, please try again");
    }

  };

  useEffect(() => {
    getSessions();
  }, [props]);


  if (uiLoading === true) {
    return (
      <main className={classes.content}>
        {uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
      </main>
    );
  } else {

  return (
    <div className={classes.root}>
      <BookingSessionsToolbar />
      <div className={classes.content}>
        <BookingSessionsTable sessions={sessions} />
      </div>
    </div>
  );
  }
};

export default BookingSessionList;
